import { appStore } from '@/store';
import { pomaLogout } from '@/components/PasswordlessOnboarding/utils';
import { logger, redirectToMerchantOnSuccess } from '@/lib';
import { SPINNER_TYPES } from '@/store/models/constants';
import { getLocale } from '@/lib/globals';

type Options = {
  isPasswordlessFlow: boolean;
  returnToMerchantUrl: string | null | undefined;
};

export const returnToMerchantClickHandler = (
  event: React.MouseEvent,
  options: Options,
): void => {
  event.preventDefault();
  const { isPasswordlessFlow, returnToMerchantUrl } = options;

  returnToMerchant({ isPasswordlessFlow, returnToMerchantUrl });
};

export const returnToMerchant = ({
  isPasswordlessFlow,
  returnToMerchantUrl,
}: Options): Promise<void> => {
  const { country, locale } = getLocale();
  const { ui: uiActions } = appStore.getActions();
  uiActions.setSpinnerType(SPINNER_TYPES.takingYouBack);
  uiActions.toggleIsFormSubmitting(true);

  if (isPasswordlessFlow) {
    return pomaLogout()
      .then(() => {
        // Redirect to merchant page
        logger.info(
          `attempting_redirect_to_merchant_after_poma_logout_in_passkey_page_${country}`,
          {
            buyerCountry: country,
            hasReturnUrl: Boolean(returnToMerchantUrl),
            locale,
          },
        );
        redirectToMerchantOnSuccess(returnToMerchantUrl);
      })
      .catch(({ message, name, stack }) => {
        logger.error(
          `attempting_redirect_to_merchant_passkey_page_poma_logout_failed_${country}`,
          {
            buyerCountry: country,
            locale,
            message,
            name,
            stack,
          },
        );
        redirectToMerchantOnSuccess(returnToMerchantUrl);
      });
  }
  logger.info(`attempting_redirect_to_merchant_in_passkey_page_${country}`, {
    buyerCountry: country,
    hasReturnUrl: Boolean(returnToMerchantUrl),
    locale,
  });
  redirectToMerchantOnSuccess(returnToMerchantUrl);
  return Promise.resolve();
};
